// Error Boundary metrics
export const ERROR_BOUNDARY_ENCOUNTER = 'error-boundary-encounter';
export const INIT_ERROR_BOUNDARY_ENCOUNTER = 'AppInitErrorBoundary.Encounter';
